import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';
import { NewClinicalFeedbackFormHelper } from '@app/clinical-feedback/new-clinical-feedback/new-clinical-feedback.helper';
import { matRichTextEditorOptions, matRichTextEdtorStyleHeight } from '@app/shared/mat-rich-text-editor/mat-rich-text-editor.component';

@Component({
    selector: 'app-rich-text-editor',
    templateUrl: './rich-text-editor.component.html',
    styleUrls: ['./quill-rich-text-editor-basic.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RichTextEditorComponent {
    matRichTextEditorOptions = matRichTextEditorOptions;
    matRichTextEdtorStyleHeight = matRichTextEdtorStyleHeight;

    @Input() formElementModel!: FormElementModel;
    @Input() parentFormGroup!: UntypedFormGroup;

    get control() {
        if (!this.formElementModel.id) {
            throw new Error(`formElementId not set for '${this.formElementModel.label}'.`);
        }

        return this.parentFormGroup.get(this.formElementModel.id);
    }

    get asterisk() {
        return NewClinicalFeedbackFormHelper.getAsteriskIfRequired(this.control);
    }
}
